import {Pipe, PipeTransform} from '@angular/core';
import Autolinker, {AutolinkerConfig} from 'autolinker';

export const LINKIFY_CLASS_NAME = 'linkify';

@Pipe({
    name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {

    constructor() {
    }

    /**
     * Link any URLs (even without scheme), email addresses or phone numbers (starting with '+' followed by country calling code).
     * This pipe also handle HTML input and will not wrap already existing anchor tags with another one.
     *
     * @param textOrHtml Text or HTML
     * @param options (optional) Options such as newWindow to have the links open in a new window, ...
     */
    transform(textOrHtml: string, options?: LinkifyOptions): string {
        return Autolinker.link(textOrHtml, {
            ...options,
            stripPrefix: false,
            replaceFn: function (match) {
                const tag = match.buildTag();
                tag.addClass(LINKIFY_CLASS_NAME);
                return tag;
            }
        });
    }
}

/**
 * Test
 */
export type LinkifyOptions = Pick<AutolinkerConfig, 'newWindow' | 'urls' | 'email' | 'phone'>;
